import { changeSelectedIntlShippingCountry } from '../actions/helpActions';
import { FREQUENTLY_SELECTED_COUNTRIES } from '../../../core/js/constants';

export function handleChangeSelectedIntlShippingCountry(store, e) {
    const selectedCountryData = _.find(store.getState().help.internationalShippingData,
                                      ({ country }) => country === e.target.value);

    store.dispatch(changeSelectedIntlShippingCountry(selectedCountryData));
}

export function sortAllOtherCountriesList(currentCountry, previousCountry){
    return currentCountry.country.localeCompare(previousCountry.country);
}

export function getShippingInformationData(state) {
    const internationalShippingCountries = _.get(state, 'help.internationalShippingData', []);
    const allOtherCountries = [];
    const frequentlySelectedCountries = [];

    for (const country of internationalShippingCountries) {
        if (FREQUENTLY_SELECTED_COUNTRIES.includes(country.country)) {
            frequentlySelectedCountries.push(country);
        } else {
            allOtherCountries.push(country);
        }
    }

    return {
        frequentlySelectedCountries: frequentlySelectedCountries,
        allOtherCountries: allOtherCountries.sort(sortAllOtherCountriesList)
    };
}
